
<template>
	<div class="container">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>

		<van-form>
			<div v-if="(form.order_status == 1 && form.financial_status == 1)|| form.order_status == 2">
				<h2 class="van-form-title">审核情况</h2>
				<van-field v-model="order_status[form.order_status]" label="审核情况" readonly />
				<van-field v-if="form.order_status == 2" v-model="form.check_remark" label="说明" readonly />
			</div>

			<h2 class="van-form-title">项目内容</h2>
			<van-field v-model="form.order_name" label="项目名称" readonly />
			<van-field v-model="form.order_code" label="订单编号" readonly />
			<van-field v-model="order_type[form.order_type]" label="订单类型" readonly />
			<van-field v-model="payment_method[form.payment_method]" label="付款方式" readonly />
			<van-field v-model="order_tax[form.order_tax]" label="是否含税" readonly />
			<van-field v-model="form.total" label="订单总额" readonly />
			<van-field v-model="form.paid_account" label="已付金额" readonly />
			<van-field v-model="form.recede_amount" label="累计退款" readonly />
			<van-field v-model="form.credit_account" label="累计收款" readonly />

			<h2 class="van-form-title">商品详情</h2>
			<van-cell-group>
				<van-cell title="商品详情" value="点击查看商品详情" @click="productDetails" />
			</van-cell-group>

			<h2 class="van-form-title">联系人</h2>
			<van-field v-model="form.receipt_name" label="收货人" readonly />
			<van-field v-model="form.receipt_phone" label="联系电话" readonly />

			<div v-if="form.payment_method == 1">
				<h2 class="van-form-title">预付信息</h2>
				<van-field v-model="form.payment_sf" label="首付" readonly />
				<van-field v-model="form.payment_hdxc" label="货到现场" readonly />
				<van-field v-model="form.payment_azwb" label="安装完毕" readonly />
				<van-field v-model="form.payment_azwys" label="安装完验收" readonly />
				<van-field v-model="form.warranty" label="质保金" readonly />
				<van-field v-model="form.warranty_days" label="质保天数" readonly />
			</div>
			<h2 class="van-form-title">下单信息</h2>
			<van-field v-model="form.user_name" label="下单人" readonly />
			<van-field v-model="form.create_date" label="下单时间" readonly />
			<van-field v-model="form.contact_person" label="联系人" readonly />
			<van-field v-model="form.deliver_date" label="交付日期" readonly />
			<van-field v-model="form.back_date" label="回款日期" readonly />
			<van-field v-model="form.return_date" label="归还日期" readonly v-if="form.payment_method == 4" />

			<h2 class="van-form-title">出货信息</h2>
			<van-field v-model="form.delivery_address" label="收货地址" readonly />
			<van-field v-model="form.beneficiary_name" label="收款银行" readonly />
			<van-field v-model="form.beneficiary_number" label="收款账号" readonly />
			<van-field v-model="form.order_remark" rows="1" autosize label="订单备注" type="textarea" readonly />

			<h2 class="van-form-title">出库记录</h2>
			<van-cell-group>
				<van-cell title="出库记录" value="点击查看出库记录" @click="recordingDetails(0)" />
			</van-cell-group>

			<h2 class="van-form-title">收款记录</h2>
			<van-cell-group>
				<van-cell title="收款记录" value="点击查看收款记录" @click="recordingDetails(1)" />
			</van-cell-group>

			<h2 class="van-form-title">退货记录</h2>
			<van-cell-group>
				<van-cell title="退货记录" value="点击查看退货记录" @click="recordingDetails(2)" />
			</van-cell-group>

			<h2 class="van-form-title">合同附件</h2>
			<van-cell-group>
			<div class="schedule" v-if="form.file_list != null">
				<!-- <p>附件列表</p> -->
				<div class="schedule-body">
					<div class="file-body">
						<div class="file-body-item" v-for="(item,index3) in file_list" :key="index3">
							<div class="img-body" v-if="isTypeImage(item.file_type)">
								<van-image width="100" height="100" :src="fileUrl + item.file_id"
									@click="imgLook(fileUrl + item.file_id)" />
							</div>
							<div class="img-body" v-else-if="isTypeMp4(item.file_type)"
								@click="lookVideo(fileUrl + item.file_id)">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">{{ item.file_name }}</div>
							</div>
							<div class="img-body" v-else-if="isType(item.file_type)"
								@click="lookfile(fileUrl + item.file_id)">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">{{ item.file_name }}</div>
							</div>
							<div class="img-body" v-else @click="clickFile">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">
									{{ item.file_name }}.{{ item.file_type }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</van-cell-group>
		</van-form>
		<van-popup v-model="videoShow" style="width: 100%" @close="closePanel">
			<video-player id="video" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
				:options="playerOptions"></video-player>
		</van-popup>
		<van-popup v-model="showPopup" style="width: 100%;height: 80%;" @opened="pdfpanel">
			<div class="m-pdf" >
				<div id="pdf-content"></div>
			</div>
		</van-popup>

		<audit-btn v-if="review_button" @audit="auditcheck"></audit-btn>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import auditBtn from "@/components/auditBtn/index";
import { post } from "@/api/order";
import { Toast } from "vant";
import global_url from "@/utils/global";
import { isImage, isMp4, istype } from "@/utils/tool";
import { ImagePreview } from "vant";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
	components: {
		navbar,
		"audit-btn": auditBtn,
	},
	data() {
		return {
			title: "订单详情",
			activeName: "index",
			order_id: this.$route.query.id,
			review_button: false,
			form: {},
			file_list: [],
			order_type: ["渠道批发", "成品制作", "工程安装", "指导安装", "产品借用"],
			order_tax:["含税", "不含税"],
			payment_method: ["全款", "预付", "欠款授信", "产品借用"],
			order_status: ["财务审核", "通过", "拒绝"],
			fileUrl: this.findUrl(),
			playerOptions: {
				autoplay: false,
				muted: false,
				preload: "auto",
				language: "zh-CN",
				aspectRatio: "16:9",
				fluid: true,
				sources: [
					{
						type: "video/mp4",
						src: "",
					},
				],
				notSupportedMessage: "此视频暂无法播放，请稍后再试",
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: false,
				},
			},
			videoShow: false,
			showPopup: false,
			pdfUrl: "",
		};
	},
	mounted() {
		this.getDetails();
	},
	methods: {
		auditcheck(val) {
			this.approval(val);
		},
		getDetails() {
			post({
				requestType: "sales_order_list_details",
				order_id: this.order_id,
			})
				.then((res) => {
					// console.log(res.obj.review_button == 0);
					this.form = res.obj;
					if (res.obj.review_button == 0) {
						this.review_button = true;
					}
					if (res.obj.file_list.length != 0) {
						this.file_list = JSON.parse(res.obj.file_list);
					}
				})
				.catch((err) => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		productDetails() {
			this.$router.push({
				path: "/order/productDetails",
				query: {
					id: this.order_id,
				},
			});
		},
		recordingDetails(type) {
			this.$router.push({
				path: "/order/recordingDetails",
				query: {
					id: this.order_id,
					type: type,
				},
			});
		},
		// 审批状态：2，拒绝，5财务预审核
		approval(mess) {
			let type = 2;
			if (!this.order_id) {
				return Toast.fail("数据异常");
			}
			if (mess == "") {
				// type = 5;
				console.log(mess, "数据原因");
				if (this.form.order_status == 3) {
					type = 4;
				} else if (this.form.order_status == 4) {
					type = 5;
					//下面这段财务审核状态为0需要审核2次
				// } else if (this.form.order_status == 5) {
				// 	type = 0;
				} else {
					type = 1;
				}
			}
			post({
				requestType: "sales_order_approval",
				order_id: this.order_id,
				order_status: type,
				check_remark: mess,
			})
				.then(() => {
					this.$route.params.listRefresh = true;
					this.$router.go(-1);
					return Toast.success("审核成功!");
				})
				.catch(() => {
					return Toast.fail("数据异常");
				});
		},
		closePanel() {
			let video = document.getElementsByTagName("video")[0];
			video.pause();
		},
		lookVideo(url) {
			console.log(url);
			this.playerOptions.sources[0].src = url;
			this.videoShow = true;
		},
		pdfpanel() {
			//先实例化
			this.pdfh5 = new Pdfh5("#pdf-content", {
				pdfurl: this.pdfUrl,
				goto: 1,
				lazy: true,
			});
			this.pdfh5.scrollEnable(true); 
		},
		lookfile(row) {
			this.showPopup = true;
			this.pdfUrl = row
			// console.log(row);

		},
		isTypeMp4(name) {
					console.log(name);
			return isMp4(name);
		},
		isType(name) {
			return istype(name);
		},
		isTypeImage(name) {
			return isImage(name);
		},
		findUrl() {
			return global_url.fileUrl;
		},
		imgLook(url) {
			ImagePreview({
				images: [url],
			});
		},
		clickFile() {
			return Toast.fail("暂不支持该文件查看");
		},
	},
};
</script>

<style lang="scss" scoped>
.container {
	padding-bottom: 30px;
}

.demo-panel .van-panel__footer {
	text-align: right;
}

.goods-panel {
	margin-top: 15px;
}

[class*="van-hairline"] {
	border: none;

	&+[class*="van-hairline"]:after {
		border: 0 solid #ebedf0;
	}
}

.input-right {
	display: flex;
	align-content: space-between;
	justify-items: center;

	.input-tag {
		display: flex;
		align-content: space-between;
		justify-items: center;
	}
}

.van-form-title {
	margin: 0;
	padding: 20px 16px 16px;
	color: rgba(69, 90, 100, 0.6);
	font-weight: normal;
	font-size: 14px;
	line-height: 16px;
}

.van-cell__value {
	color: #1989fa;
}
.m-pdf {
	// 保证pdf区域铺满整个屏幕
	// 方法1：使用vw和vh视窗单位，1vw=视窗宽度的1%；1vh=视窗高度的1%
	// width: 100vw;
	// height: 100vh;
	// 方法2：使用fixed定位
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
}

.file-body {
	width: calc(100% + 10px);
	padding: 0;
	display: flex;
	flex-wrap: wrap;

	.file-body-item {
		list-style: none;
		flex: 0 0 calc(33.33% - 10px);
		margin-right: 10px;
	}
}

.schedule {
	margin-top: 1px;
	margin-bottom: 12px;
	// padding-left:15px;
	margin-left: 20px;
	margin-right: 20px;

	// overflow: hidden;
	.file-body {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-top: 2px;

		&-item {
			position: relative;
			margin: 0 2px 2px 0;
			cursor: pointer;

			.img-body {
				display: block;
				width: 80px;
				height: 80px;
				overflow: hidden;
				border-radius: 8px;
				box-shadow: #ebedf0 0 4px 12px;
				text-align: center;

				img {
					object-fit: cover;
					display: block;
					width: 100%;
					height: 100%;
				}

				.file-icon {
					position: relative;
					display: inline-block;
					font: normal normal normal 14px/1 "vant-icon";
					font-size: inherit;
					text-rendering: auto;
					-webkit-font-smoothing: antialiased;
					color: #646566;
					font-size: 20px;
					margin-top: 15px;
				}

				.file-name {
					box-sizing: border-box;
					width: 100%;
					margin-top: 4px;
					padding: 0 4px;
					color: #646566;
					font-size: 12px;
					text-align: center;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
				}
			}
		}
	}
}
</style>
